export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q04_a.7896e1d7.png";